import { render } from "./ProductImgModal.vue?vue&type=template&id=61b67b82"
import script from "./ProductImgModal.vue?vue&type=script&lang=js"
export * from "./ProductImgModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__